var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTags = function SvgTags(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9CA9BD",
    fillRule: "nonzero",
    d: "M8.8 0c-.41 0-.82.156-1.131.469l-7.2 7.2a1.6 1.6 0 0 0 0 2.262l1.25 1.25c.142-.54.413-1.039.818-1.443l7.2-7.2A3.18 3.18 0 0 1 12 1.6h4.356A3.19 3.19 0 0 0 13.6 0zM12 3.2c-.41 0-.82.156-1.131.469l-7.2 7.2a1.6 1.6 0 0 0 0 2.262l6.4 6.4a1.6 1.6 0 0 0 2.262 0l7.2-7.2c.313-.312.469-.721.469-1.131V6.4a3.2 3.2 0 0 0-3.2-3.2zm4.8 1.6a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2"
  })));
};
export default SvgTags;